<div class="warning-container" *ngIf="incompleteConfirmedEventRegistrations.length > 0">
    <h5>{{ "eventRegistrations.incompleteRegistrations.title" | translate }}</h5>
    <p>{{ "eventRegistrations.incompleteRegistrations.text" | translate }}</p>
</div>
